import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField, Chip } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { Saint } from '../../types';

interface Props { items: Saint[]; loading: boolean; total: number; page: number; limit: number; onPageChange: (p: number) => void; onEdit: (i: Saint) => void; onDelete: (id: number) => void; }

export function SaintsTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete }: Props) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead><TableRow>
          <TableCell>Заголовок</TableCell><TableCell>Слаг</TableCell><TableCell>Блоков</TableCell><TableCell>Действия</TableCell>
        </TableRow></TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>{item.title}</TableCell>
              <TableCell>{item.slug}</TableCell>
              <TableCell><Chip size="small" label={Array.isArray(item.content) ? (item.content as unknown[]).length : 0} /></TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Редактировать"><IconButton size="small" onClick={() => onEdit(item)}><Edit fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Удалить"><IconButton size="small" onClick={() => onDelete(item.id)} sx={{ color: 'error.main' }}><Delete fontSize="small" /></IconButton></Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && !loading && (<TableRow><TableCell colSpan={4} align="center"><Typography color="text.secondary">Данные не найдены</Typography></TableCell></TableRow>)}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, p) => onPageChange(p + 1)} rowsPerPage={limit} onRowsPerPageChange={() => {}} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}
export function SaintsToolbar({ search, onSearchChange }: { search: string; onSearchChange: (v: string) => void }) {
  return (<Box sx={{ display: 'flex', gap: 2, mb: 2 }}><TextField label="Поиск" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 260 }} /></Box>);
}
